import { dGet } from '@core/utils'
import mainStore from '@components/Main/store'
import {
  LITE_APP_PATH,
  LITE_APP_PATH_A,
  LITE_APP_SELECT_PATH,
  LITE_APP_SELECT_PATH_A
} from '@constant'

export const getLiteAppType = () => {
  return dGet(mainStore, 'shopInfo.merchant_weapp.type', -1)
}

export const liteAppNotOpen = () => {
  return getLiteAppType() == -1
}

/**
 * 获取小程序跳转地址
 * type 区分是否带 hash #
 * 带 # 号用于 window.open，不带用于路由
 */
export const getLiteAppPath = (type = 'link') => {
  let obj = {}

  if (type === 'link') {
    obj = {
      '-1': LITE_APP_SELECT_PATH,
      '1': LITE_APP_PATH,
      '2': LITE_APP_PATH
    }
  } else {
    obj = {
      '-1': LITE_APP_SELECT_PATH_A,
      '1': LITE_APP_PATH_A,
      '2': LITE_APP_PATH_A
    }
  }

  return obj[String(getLiteAppType())]
}
